import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const SPACEBAR_ACTIVITY_FRAGMENT = gql `
  fragment SpacebarActivityFragment on SpacebarActivity {
    targetKey
    rounds {
      steps {
        answer
        isTyped
        activityImage: optionalImage {
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default SPACEBAR_ACTIVITY_FRAGMENT;
